export default __webpack_public_path__ + "static/media/a012-10.932a6f1c.svg";